import React from 'react';

// import Container from '@material-ui/core/Container';
// import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
// import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
// import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';

import useAuthContext from '../../hooks/useAuthContext';
import useNavContext from '../../hooks/useNavContext';
import useMsgContext from '../../hooks/useMsgContext';
import useDeeplinkContext from '../../hooks/useDeepLinkContext';
import useInitialSetupContext from '../../hooks/useInitContext';
import useSelectedMerchantContext from '../../hooks/useMerchantContext';
import useSelectedStampCardContext from '../../hooks/useStampCardContext';
import AddToHomeScreenDialog from '../../components/Dialogs/AddToHomeScreenDialog';

import { googleLogout } from '@react-oauth/google';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  actionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  toolbar: {
    height: 40,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    padding: theme.spacing(3),
  },
  box: {
    flex: 1,
    display: 'flex',
  },
  actions: {
    marginLeft: 'auto',
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
  },
  homeContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: theme.spacing(),
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    width: '100%',
  },
  listItemContainer: {
    marginLeft: 0,
    borderTop: `0.5px solid ${theme.palette.divider}`,
    borderBottom: `0.5px solid ${theme.palette.divider}`,
  },
  logo: {
    fontSize: 36,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(4),
  },
  moreText: {
    fontWeight: theme.typography.fontWeightBold,
  },
  arrowIcon: {
    fontSize: 45,
    marginLeft: 'auto',
  },
}));

export default function MoreOption() {
  const classes = useStyles();
  const auth = useAuthContext();
  const nav = useNavContext();
  const msg = useMsgContext();
  const deeplink = useDeeplinkContext();
  const initialSetup = useInitialSetupContext();
  const selectedMerchant = useSelectedMerchantContext();
  const selectedStampCard = useSelectedStampCardContext();
  const history = useHistory();
  const [isAddToHomeScreenDialogOpen, setIsAddToHomeScreenDialogOpen] =
    React.useState(false);
  const [device, setDevice] = React.useState('');

  React.useEffect(() => {
    const userAgent =
      window.navigator.userAgent ||
      window.navigator.vendor ||
      (window as any).opera;

    // iOS detection
    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      setDevice('iOS Device');
    } else if (/android/i.test(userAgent)) {
      setDevice('Android Device');
    } else {
      setDevice('Unknown Device');
    }
  }, []);

  const handleLogOut = async () => {
    if (auth && nav && msg) {
      auth.removeSession();
      nav.removeNav();
      msg.removeMsg();
      history.replace({});
      history.push(`/`);
    }
    if (deeplink) {
      deeplink.removeDeeplink();
    }
    if (initialSetup) {
      initialSetup.removeInit();
    }
    if (selectedMerchant) {
      selectedMerchant.removeMerchant();
    }
    if (selectedStampCard) {
      selectedStampCard.removeStampCard();
    }
    try {
      googleLogout();
      console.log('user logout');
    } catch (e) {
      console.log('Error: ', e);
    }
  };

  const handleAddToHomeScreen = () => {
    setIsAddToHomeScreenDialogOpen(true);
  };

  const handleAbout = () => {
    history.push('/about');
  };

  const handleProfile = () => {
    history.push('/profile');
  };

  return (
    <>
      <div className={classes.toolbar}>
        <div className={classes.homeContainer}>
          <Typography variant="h4" className={classes.title}>
            More
          </Typography>
        </div>
      </div>
      <List>
        <ListItem
          button
          key="profile"
          onClick={handleProfile}
          className={classes.listItemContainer}
        >
          <div className={classes.contentContainer}>
            <AccountCircleIcon className={classes.logo} />
            <Typography variant="h5" className={classes.moreText}>
              Profile
            </Typography>
            <ChevronRightIcon className={classes.arrowIcon} />
          </div>
        </ListItem>
        <ListItem
          button
          key="about"
          onClick={handleAbout}
          className={classes.listItemContainer}
        >
          <div className={classes.contentContainer}>
            <InfoIcon className={classes.logo} />
            <Typography variant="h5" className={classes.moreText}>
              About
            </Typography>
            <ChevronRightIcon className={classes.arrowIcon} />
          </div>
        </ListItem>
        <ListItem
          button
          key="home_screen"
          onClick={handleAddToHomeScreen}
          className={classes.listItemContainer}
        >
          <div className={classes.contentContainer}>
            <AddBoxOutlinedIcon className={classes.logo} />
            <Typography variant="h5" className={classes.moreText}>
              Add to Home Screen
            </Typography>
          </div>
        </ListItem>
        <ListItem
          button
          key="logout"
          onClick={handleLogOut}
          className={classes.listItemContainer}
        >
          <div className={classes.contentContainer}>
            <ExitToAppOutlinedIcon className={classes.logo} />
            <Typography variant="h5" className={classes.moreText}>
              Logout
            </Typography>
          </div>
        </ListItem>
      </List>
      <AddToHomeScreenDialog
        open={isAddToHomeScreenDialogOpen}
        onClose={() => {
          setIsAddToHomeScreenDialogOpen(false);
        }}
        device={device}
      />
    </>
  );
}
